import React, { Fragment } from 'react';
import universal from 'react-universal-component';
import { Global, Brands } from '@core-ui/react-stitch';
import BreadcrumbsCLP from '../breadcrumbs';
import Copyblock from '../copyblock';
import InlineFacetTags from '../inline-facet-tags';
import DivisionNav from '../division-nav';
import PageHeader from '../page-header';
import { ProductGridContainer } from '../product-grid-container';
import { useClpState } from '../../providers/app-state-provider';
import { useBRRedesign } from '../../hooks/br-redesign.hook';
import { useMobile } from '../../hooks/mobile.hook';
import { getFullWidth, getStyles, globalStyles } from './styles';

/**
 * To-Do:
 * When implementing SSR for rail-container, remove react-universal-component wrapper & import rail-container directly
 */
const RailContainer = universal(import('../rail-container'));

export const CustomLandingPage = (): JSX.Element => {
  const isBRRedesign = useBRRedesign();
  const isMobileStyle = useMobile() || isBRRedesign;
  const { brand } = useClpState();

  const isBananaRepublic = brand === Brands.BananaRepublic;

  const DefaultView = (): JSX.Element => (
    <Fragment>
      <RailContainer />
      <div css={getFullWidth}>
        <PageHeader />
        <InlineFacetTags />
        <ProductGridContainer />
        {(isBananaRepublic) && <BreadcrumbsCLP isBananaRepublic />}
      </div>
    </Fragment>
  );

  const MobileView = (): JSX.Element => (
    <Fragment>
      <PageHeader />
      <RailContainer />
      <ProductGridContainer />
      <DivisionNav />
    </Fragment>
  );

  return (
    <Fragment>
      <Global styles={globalStyles(isBRRedesign)} />
      {(!isMobileStyle && !isBananaRepublic) && <BreadcrumbsCLP />}
      <div
        className="main-content"
        data-testid="main-content"
        css={getStyles(isMobileStyle, isBRRedesign)}
      >
        {
          isMobileStyle
            ? <MobileView />
            : <DefaultView />
        }
      </div>
      <Copyblock />
    </Fragment>
  );
};
